import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EntitiesService } from '../../../services/entities/entities.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingService } from '../../loading/loading.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { AlertComponent } from '../../alert/alert.component';
import { finalize, take, Subscription } from 'rxjs';

@Component({
  selector: 'app-create-entities',
  templateUrl: './create-entities.component.html',
  styleUrls: ['./create-entities.component.scss']
})
export class CreateEntitiesComponent   {





}
